require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./workshops-pov-statement.json") })
        }
      }, "path---workshops-pov-statement");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---workshops-pov-statement!./.cache/json/workshops-pov-statement.json
// module id = 506
// module chunks = 231608221292675